import React from 'react';

import Chevron from '../../images/Chevron';

import { Link } from 'gatsby';

export interface IHeaderProps {
  className?: string;
  isSideNav?: boolean;
  activeClassName?: string;
}

export default function Links({ className, activeClassName, isSideNav = false }: IHeaderProps) {
  const isCurrentGroup = (group: { name: string; to: string }[]) => {
    if (
      typeof location !== 'undefined' &&
      group.findIndex((o) => location.pathname.startsWith(o.to)) !== -1
    ) {
      return activeClassName;
    } else {
      return;
    }
  };

  const changeYourLife = [
    {
      name: 'Psychology of Spending',
      to: '/tag/psychology-of-spending/',
    },
    {
      name: 'Lifestyle Creep/Inflation',
      to: '/tag/lifestyle-creep/',
    },
    {
      name: 'Digital Nomad Life',
      to: '/tag/digital-nomad-life/',
    },
    {
      name: 'Travel and Lifestyle',
      to: '/tag/travel-and-lifestyle/',
    },
    {
      name: 'Financial Independence',
      to: '/tag/financial-independence/',
    },
    {
      name: 'How Life-Changing Things Happen',
      to: '/tag/how-life-changing-things-happen/',
    },
  ];

  const saveMoney = [
    {
      name: 'Building Wealth Best Practices',
      to: '/tag/build-wealth/',
    },
    {
      name: 'Money-Saving Habits',
      to: '/tag/money-saving-habits/',
    },
    {
      name: 'Millennial Money',
      to: '/tag/millennial-money/',
    },
    {
      name: 'Generating Income',
      to: '/tag/generating-income/',
    },
    {
      name: 'Getting out of Debt',
      to: '/tag/getting-out-of-debt/',
    },
    {
      name: 'Opportunities to Save',
      to: '/tag/opportunities-to-save/',
    },
  ];

  const retireSooner = [
    {
      name: 'Retire Early',
      to: '/tag/retire-early/',
    },
    {
      name: 'Retire by 40',
      to: '/tag/retire-by-40/',
    },
    {
      name: 'RV Retirement',
      to: '/tag/rv-retirement/',
    },
  ];

  return (
    <ul className={className}>
      <li>
        <Link activeClassName={activeClassName} to="/posts/">
          Latest
        </Link>
      </li>
      <li>
        <Link activeClassName={activeClassName} to="/popular/">
          Popular
        </Link>
      </li>
      <li>
        {isSideNav && (
          <div className={isCurrentGroup(changeYourLife)}>
            Life <Chevron rotate={90} />
          </div>
        )}
        <ul>
          {changeYourLife.map(({ name, to }, key) => (
            <li key={key}>
              <Link activeClassName={activeClassName} to={to}>
                {name}
              </Link>
            </li>
          ))}
        </ul>
        {!isSideNav && (
          <div className={isCurrentGroup(changeYourLife)}>
            Life <Chevron rotate={90} />
          </div>
        )}
      </li>
      <li>
        {isSideNav && (
          <div className={isCurrentGroup(saveMoney)}>
            Money <Chevron rotate={90} />
          </div>
        )}
        <ul>
          {saveMoney.map(({ name, to }, key) => (
            <li key={key}>
              <Link activeClassName={activeClassName} to={to}>
                {name}
              </Link>
            </li>
          ))}
        </ul>
        {!isSideNav && (
          <div className={isCurrentGroup(saveMoney)}>
            Money <Chevron rotate={90} />
          </div>
        )}
      </li>
      <li>
        {isSideNav && (
          <div className={isCurrentGroup(retireSooner)}>
            Planning <Chevron rotate={90} />
          </div>
        )}
        <ul>
          {retireSooner.map(({ name, to }, key) => (
            <li key={key}>
              <Link activeClassName={activeClassName} to={to}>
                {name}
              </Link>
            </li>
          ))}
        </ul>
        {!isSideNav && (
          <div className={isCurrentGroup(retireSooner)}>
            Planning <Chevron rotate={90} />
          </div>
        )}
      </li>
      <li>
        <Link activeClassName={activeClassName} to="/about/">
          About
        </Link>
      </li>
      <li>
        <Link activeClassName={activeClassName} to="/opt-in/">
          Opt In
        </Link>
      </li>
    </ul>
  );
}
